import {Cloudinary} from '@cloudinary/url-gen';
import {fill, fit, scale} from '@cloudinary/url-gen/actions/resize';
import * as constants from "./constants";

export const cld = new Cloudinary({
  cloud: {cloudName: constants.CLOUDINARY_CLOUD_NAME}
});

/**
 * Generates a CloudinaryImage object with optional transformations.
 * * @param {String} url - The raw Cloudinary URL from the database
 * @param url
 * @param {Object} transformations - Optional. e.g., { width: 50, height: 50, crop: 'fit' }
 * @returns {CloudinaryImage | null}
 */
export const getCloudinaryImage = (url, transformations = {}) => {
  if (!url) {
    return null;
  }

  const parts = url.split('/upload/');
  let publicId = url;

  if (parts.length > 1) {
    publicId = parts[1].replace(/^v\d+\//, '');
  }

  let img = cld.image(publicId);
  img.format('auto').quality('auto');

  if (transformations.width || transformations.height) {
    const cropMode = transformations.crop || 'scale';

    let resizeAction;
    if (cropMode === 'fill') {
      resizeAction = fill();
    } else if (cropMode === 'fit') {
      resizeAction = fit();
    } else {
      resizeAction = scale();
    }

    if (transformations.width) {
      resizeAction.width(transformations.width);
    }
    if (transformations.height) {
      resizeAction.height(transformations.height);
    }

    img.resize(resizeAction);
  }

  return img;
};